const TOTP_ISSUER = "CheemsPay";
const INTERNAL_EMAIL_SUFFIX = "@users.invalid";
const FALLBACK_ACCOUNT_LABEL = "account";

function safeAccountLabel(accountLabel?: string | null): string {
  const trimmed = accountLabel?.trim();
  if (!trimmed || trimmed.toLowerCase().endsWith(INTERNAL_EMAIL_SUFFIX)) {
    return FALLBACK_ACCOUNT_LABEL;
  }
  return trimmed;
}

export function formatTotpEnrollmentUri(
  totpUri: string,
  accountLabel?: string | null,
): string {
  const parsed = new URL(totpUri);
  if (
    parsed.protocol !== "otpauth:" ||
    parsed.hostname !== "totp" ||
    !parsed.searchParams.get("secret")
  ) {
    throw new Error("Invalid TOTP enrollment URI");
  }

  parsed.searchParams.set("issuer", TOTP_ISSUER);
  const label = [
    encodeURIComponent(TOTP_ISSUER),
    encodeURIComponent(safeAccountLabel(accountLabel)),
  ].join(":");

  return `otpauth://totp/${label}?${parsed.searchParams.toString()}`;
}
